import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { Fragment, memo, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikProps, FormikTouched } from 'formik';
import { LastStepVM, TextActVM } from 'civil-status/view-models/step-form';
import Form from './form';

interface TextAnnotationOldProps {
  formContext: FormikProps<LastStepVM>;
  disabled?: boolean;
}

const TextAnnotationOldComponent = ({
  formContext,
}: TextAnnotationOldProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const values: TextActVM = useMemo(() => {
    return formContext.values?.textAnnotationOld || {};
  }, [formContext.values?.textAnnotationOld]);

  const onChange = useEventCallback((key: keyof TextActVM, value: TextActVM[keyof TextActVM]) => {
    formContext.setFieldValue('textAnnotationOld', {
      ...values,
      [key]: value,
    });
  });

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="accordion-text-act-content"
          id="accordion-text-act-header"
          expandIcon={<ExpandMore />}
        >
          <Typography style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            Testo annotazione
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form
            disabled
            values={values}
            onChange={onChange}
            errors={formContext.errors.textAnnotationOld as FormikErrors<TextActVM>}
            touched={formContext.touched.textAnnotationOld as FormikTouched<TextActVM>}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

TextAnnotationOldComponent.displayName = 'Accordion Text Annotation Old Component';

const TextAnnotationOld = memo(TextAnnotationOldComponent);

export default TextAnnotationOld;
